import React from "react";
import { useIntl } from "react-intl";
import { Row, Col, Typography } from "antd";

import ExternalLink from "../../app/generic/externalLink";

const { Paragraph, Title, Text } = Typography;

const Link = ({ href }) => (
  <ExternalLink href={href} id="messages.here" defaultMessage="zde" />
);

const ConsignmentImportInstructions = () => {
  const intl = useIntl();
  return (
    <Row>
      <Col>
        <Title level={3}>
          {intl.formatMessage({
            id: "consignment.import.dataFormat",
            defaultMessage: "Popis datového formátu zásilky",
          })}
        </Title>
        <Paragraph>
          <Text>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.attributes",
              defaultMessage:
                "Pro všechny atributy platí stejné omezení jako při vytváření zásilky pomocí webového formuláře. Atributy nejsou až na výjimky povinné.",
            })}
          </Text>
        </Paragraph>
        <Paragraph>
          <Text>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.countries",
              defaultMessage:
                "Státy v adresách je možné zvolit dle aktuální nabídky vzhledem k vybranému produktu. Pro tuzemské produkty (ECD_B2B, ECD_B2C, ELD a ERD) je možná pouze CZ. Množinu zemí pro produkty ECI, ECI_B2C, ERI a ELI Vám sdělí obchodní zástupce, případně je možné si ověřit dostupnost státu ve formuláři pro vytvoření zásilky.",
            })}
          </Text>
        </Paragraph>
        <Paragraph>
          <Text>
            {intl.formatMessage(
              {
                id: "consignment.import.dataFormat.collis",
                defaultMessage:
                  'Kusů je možné zadat v rámci jedné zásilky více, kdy se jednotlivé hodnoty atributu kusů oddělují, pro formát xlsx, dle ve formuláři zadaného oddělovače kusů a pro csv uvozením více atributů kusu do znaků "" (příklad zadání více kusů {bold}1;1;1{bold};"karton;paleta;sud";"zdrav.materiál;beton;cihly";"31;30;99";"30;29;98";"29;28;97";"55;54;53"). Pro kusy platí omezení na jednotlivé rozměry dle aktuálních obchodních podmínek.',
              },
              { bold: <Text strong>"</Text> }
            )}
          </Text>
        </Paragraph>
        <Paragraph>
          <Text>
            {intl.formatMessage(
              {
                id: "consignment.import.dataFormat.flagText",
                defaultMessage:
                  "V případě doplňkových služeb, kde se zadává pouze {flag}, je možné doplnit hodnoty true, t, ano, a, yes nebo y. V případě vyplnění jiné hodnoty není služba aktivní.",
              },
              {
                flag: (
                  <Text strong underline>
                    {intl.formatMessage({
                      id: "consignment.import.dataFormat.flag",
                      defaultMessage: "příznak",
                    })}
                  </Text>
                ),
              }
            )}
          </Text>
        </Paragraph>
        <ol>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.products",
              defaultMessage:
                "kód produktu zásilky, dostupné hodnoty jsou dle Vám dostupných produktů; možné hodnoty jsou ECD_B2C (Home Delivery Domestic), ECD_B2B (DHL Road Freight Standard Domestic (Euroconnect Domestic)), ECI (DHL Road Freight Standard International (Euroconnect International)), ECI_B2C (Home Delivery International), ERI (DHL Road Freight Priority International (Eurapid)), ERD (DHL Road Freight Priority Domestic (Eurapid)),  ELD (DHL Road Freight Direct Domestic (Euroline Domestic)) a ELI (DHL Road Freight Direct International (Euroline International))",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.reference",
              defaultMessage:
                "zákaznická reference; je doporučeno ji vyplnit pro lepší identifikaci nejen výsledku importu dané zásilky",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.pickup.name",
              defaultMessage: "název odesílatele",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.pickup.subname",
              defaultMessage: "sekundární název odesílatele",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.pickup.street",
              defaultMessage: "název ulice odesílatele",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.pickup.streetNumber",
              defaultMessage: "číslo popisné/orientační odesílatele",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.pickup.localDestination",
              defaultMessage: "místní určení (upřesnění adresy) odesílatele",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.pickup.city",
              defaultMessage: "město odesílatele",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.pickup.zipCode",
              defaultMessage:
                "PSČ odesílatele; formát dle vybraného státu odesílatele (vnitřní mezery budou smazány)",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.pickup.country",
              defaultMessage:
                "stát odesílatele; ve dvoumístném (ISO 3166-1 Alpha-2) nebo třímístném formátu (ISO 3166-1 Alpha-3)",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.pickup.contactPerson",
              defaultMessage: "kontaktní osoba odesílatele",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.pickup.contactPhone",
              defaultMessage:
                "telefonní kontakt na odesílatele; validní formát dle daného předčíslí, v případě, že není předčíslí zadané, je doplněno české (+420); předčíslí je možné zadat ve formátu +XX nebo 00XX nebo XX",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.pickup.contactEmail",
              defaultMessage:
                "emailový kontakt na odesílatele; požadován validní formát emailu",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.delivery.name",
              defaultMessage: "název příjemce",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.delivery.subname",
              defaultMessage: "sekundární název příjemce",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.delivery.street",
              defaultMessage: "název ulice příjemce",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.delivery.streetNumber",
              defaultMessage: "číslo popisné/orientační příjemce",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.delivery.localDestination",
              defaultMessage: "místní určení (upřesnění adresy) příjemce",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.delivery.city",
              defaultMessage: "město příjemce",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.delivery.zipCode",
              defaultMessage:
                "PSČ příjemce; formát dle vybraného státu příjemce (vnitřní mezery budou smazány)",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.delivery.country",
              defaultMessage:
                "stát příjemce; ve dvoumístném (ISO 3166-1 Alpha-2) nebo třímístném formátu (ISO 3166-1 Alpha-3)",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.delivery.contactPerson",
              defaultMessage: "kontaktní osoba příjemce",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.delivery.contactPhone",
              defaultMessage:
                "telefonní kontakt na příjemce; validní formát dle daného předčíslí, v případě, že není předčíslí zadané, je doplněno české (+420); předčíslí je možné zadat ve formátu +XX nebo 00XX nebo XX",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.delivery.contactEmail",
              defaultMessage:
                "emailový kontakt na příjemce; požadován validní formát emailu",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.colli.count",
              defaultMessage: "počet/počty kusů",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.colli.wrapping",
              defaultMessage:
                "obal/obaly kusů; dostupné hodnoty dle možností ve formuláři pro zadání zásilky",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.colli.description",
              defaultMessage: "popis/popisy kusů",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.colli.barcode",
              defaultMessage:
                "kód/kódy kusů; nutné zadat validní formát kódu kusu, pokud nemáte vlastní číselnou řadu nebo si nejste jisti formátem, bude kód automaticky doplněn při odesílání dat do DHL",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.colli.height",
              defaultMessage:
                "výška/výšky kusů; přirozené číslo, které se řídí maximální hodnotou pro daný produkt",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.colli.width",
              defaultMessage:
                "šířka/šířky kusů; přirozené číslo, které se řídí maximální hodnotou pro daný produkt",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.colli.length",
              defaultMessage:
                "délka/délky kusů; přirozené číslo, které se řídí maximální hodnotou pro daný produkt",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.colli.weight",
              defaultMessage:
                "váha/váhy kusů; přirozené číslo, které se řídí maximální hodnotou pro daný produkt",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.codPrice",
              defaultMessage: "doběrečná částka; přirozené číslo",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.codCurrency",
              defaultMessage:
                "měna dobírky; ve formátu ISO 4217, nyní dostupné pro CZ (CZK), SK (EUR) a PL (PLN), defaultní hodnota je CZK",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.codVariableSymbol",
              defaultMessage:
                "variabilní symbol dobírky; pouze čísla, maximální délka je 10",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.documentsBack",
              defaultMessage:
                "služba Dokumenty zpět; příznak, pouze pro produkty ECD_B2C a ECD_B2B",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.insurance",
              defaultMessage: "služba Připojištění; příznak",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.peur",
              defaultMessage:
                "služba EUR palety zpět; přirozené číslo, pouze pro produkty ECD_B2C a ECD_B2B",
            })}
          </li>
          <li>
            {/* {intl.formatMessage({
              id: "consignment.import.dataFormat.services.adr",
              defaultMessage:
                "ADR informace; v případě zadání je zásilka brána jako ADR, vyplňuje se ve formátu - UN číslo, oficiální pojmenování, třída, obalová skupina a množství",
            })} */}
            <b>
              {intl.formatMessage({
                id: "consignment.import.dataFormat.colli.stackability",
                defaultMessage:
                  'stohovatelnost/stohovatelnosti kusů; příznak, například pro 3 kusy se zadává jako "a;n;a"',
              })}
            </b>
          </li>
          <li>
            {/* {intl.formatMessage({
              id: "consignment.import.dataFormat.services.cash",
              defaultMessage:
                "přepravné placeno hotově; pokud je hodnota vyplněna, vybere se částka za přepravné v hotovosti, možnosti zadání jsou hodnoty 1 (příjemce) a 2 (odesílatel), pouze pro produkty ECD_B2C a ECD_B2B",
            })} */}
            <i>
              {intl.formatMessage({
                id: "consignment.import.dataFormat.services.free",
                defaultMessage: "nepoužíváno - pro budoucí použití",
              })}
            </i>
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.pickupFront",
              defaultMessage:
                "manipulace pomocí hydraulického čela při svozu zásilky; příznak",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.pickupCart",
              defaultMessage:
                "manipulace pomocí paletového vozíku při svozu zásilky; příznak",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.deliveryFront",
              defaultMessage:
                "manipulace pomocí hydraulického čela při rozvozu zásilky; příznak",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.deliveryCart",
              defaultMessage:
                "manipulace pomocí paletového vozíku při rozvozu zásilky; příznak",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.lift",
              defaultMessage:
                "služba Výnos do patra; příznak, pouze pro produkt ECD_B2C",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.oldBack",
              defaultMessage:
                "služba Odvoz starého spotřebiče; příznak, pouze pro produkt ECD_B2C",
            })}
          </li>
          <li>
            {/* {intl.formatMessage({
              id: "consignment.import.dataFormat.services.sms",
              defaultMessage:
                "odeslání SMS příjemci zásilky; příznak, v případě nevyplnění je doplněna hodnota z klientského nastavení",
            })} */}
            <i>
              {intl.formatMessage({
                id: "consignment.import.dataFormat.services.free",
                defaultMessage: "nepoužíváno - pro budoucí použití",
              })}
            </i>
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.personalPickup",
              defaultMessage:
                "osobní podání na depu DHL; v případě zadání kódu depa DHL (ve formátu PRG, OSR atp. - dle dostupných dep CZ DHL) je očekáváno vlastní dodání zásilky na vybrané české depo DHL",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.personalDelivery",
              defaultMessage:
                "osobní odběr na depu DHL; v případě zadání kódu depa DHL (ve formátu PRG, OSR atp. - dle dostupných CZ dep DHL) je očekáván vlastní odběr zásilky z vybraného českého depa DHL",
            })}
          </li>
          <li>
            <i>
              {intl.formatMessage({
                id: "consignment.import.dataFormat.services.free",
                defaultMessage: "nepoužíváno - pro budoucí použití",
              })}
            </i>
          </li>
          <li>
            <b>
              {intl.formatMessage({
                id: "consignment.import.dataFormat.services.fdd",
                defaultMessage:
                  "FDD; příznak, datum se zadává ve sloupci 61, pouze pro produkt ECI",
              })}
            </b>
          </li>
          <li>
            <b>
              {intl.formatMessage({
                id: "consignment.import.dataFormat.services.nationalTransportId",
                defaultMessage:
                  "EKAER (HU), SENT (PL), UIT (RO); pokud si přejete zadat EKAER/SENT/UIT free, zadejte prosím 'N/A'; maximální délka 20, pouze při doručení do HU/PL/RO, pouze pro produkt ECI, ECI_B2C a ERI",
              })}
            </b>
          </li>
          <li>
            <b>
              {intl.formatMessage({
                id: "consignment.import.dataFormat.services.timeSlotBooking",
                defaultMessage:
                  "Time-slot booking; příznak, pouze pro produkt ECI, ECI_B2C, ERD a ERI",
              })}
            </b>
          </li>
          <li>
            <b>
              {intl.formatMessage({
                id: "consignment.import.dataFormat.services.preAdviseDelivery",
                defaultMessage:
                  "Pre-advise delivery; příznak, pouze pro produkt ECI, ECI_B2C, ERD a ERI",
              })}
            </b>
          </li>
          <li>
            {intl.formatMessage(
              {
                id: "consignment.import.dataFormat.services.incoterms",
                defaultMessage:
                  "parita (incoterms); výčet hodnot {link}, pouze pro produkt ECI, ECI_B2C a ERI",
              },
              {
                link: (
                  <Link href="https://www.logistics.dhl/global-en/home/our-divisions/freight/customer-service/incoterms-2020.html" />
                ),
              }
            )}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.deliveryDate",
              defaultMessage:
                "počáteční datum doručení; ve formátu d.m.rrrr (den, měsíc, rok), pouze pro produkt ELI a ELD",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.price",
              defaultMessage: "hodnota zásilky; přirozené číslo",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.priceCurrency",
              defaultMessage:
                "měna hodnoty zásilky; ve formátu ISO 4217; dostupné měny CZK, PLN, USD, EUR; defaultní hodnota je CZK",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.pickupDate",
              defaultMessage:
                "(pro ELD a ELI počáteční) datum svozu; ve formátu d.m.rrrr (den, měsíc, rok); nepovinné, pokud nebude zadáno, přiřadí se automaticky",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.pickupDateTo",
              defaultMessage:
                "koncové datum svozu; ve formátu d.m.rrrr (den, měsíc, rok), pouze pro produkt ELI a ELD",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.deliveryDateTo",
              defaultMessage:
                "koncové datum doručení; ve formátu d.m.rrrr (den, měsíc, rok), pouze pro produkt ELI a ELD",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.services.note",
              defaultMessage: "poznámka k přepravě",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.invoice.name",
              defaultMessage: "název fakturanta",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.invoice.subname",
              defaultMessage: "sekundární název fakturanta",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.invoice.street",
              defaultMessage: "název ulice fakturanta",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.invoice.streetNumber",
              defaultMessage: "číslo popisné/orientační fakturanta",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.invoice.localDestination",
              defaultMessage: "místní určení (upřesnění adresy) fakturanta",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.invoice.city",
              defaultMessage: "město fakturanta",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.invoice.zipCode",
              defaultMessage:
                "PSČ fakturanta; formát dle vybraného státu fakturanta (vnitřní mezery budou smazány)",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.invoice.country",
              defaultMessage:
                "stát fakturanta; ve dvoumístném (ISO 3166-1 Alpha-2) nebo třímístném formátu (ISO 3166-1 Alpha-3)",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.invoice.contactPerson",
              defaultMessage: "kontaktní osoba fakturanta",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.invoice.contactPhone",
              defaultMessage:
                "telefonní kontakt na fakturanta; validní formát dle daného předčíslí, v případě, že není předčíslí zadané, je doplněno české (+420); předčíslí je možné zadat ve formátu +XX nebo 00XX nebo XX",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.invoice.contactEmail",
              defaultMessage:
                "emailový kontakt na fakturanta; požadován validní formát emailu",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.pickup.save",
              defaultMessage:
                "uložení adresy odesílatele jako zákazníka; příznak; nepovinná hodnota, defaultní hodnota je false",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.delivery.save",
              defaultMessage:
                "uložení adresy přijemce jako zákazníka; příznak; nepovinná hodnota, defaultní hodnota je true",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.invoice.save",
              defaultMessage:
                "uložení adresy fakturanta jako zákazníka; příznak; nepovinná hodnota, defaultní hodnota je false",
            })}
          </li>
          <li>
            {intl.formatMessage(
              {
                id: "consignment.import.dataFormat.adr.unClass",
                defaultMessage:
                  "ADR - Třída nebezpečnosti, povolené hodnoty 1.4, 2.1, 2.2, 3, 4.1, 5.1, 6.1, 8, 9",
              }
              /*{
                url: (
                  <Link
                    href="https://www.hse.gov.uk/cdg/manual/classification.htm"
                  />
                ),
              }*/
            )}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.adr.unCode",
              defaultMessage: "ADR - UN číslo; ve formátu XXXX (3333)",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.adr.chemicalName",
              defaultMessage: "ADR - chemický název",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.adr.packagingGroup",
              defaultMessage:
                "ADR - obalová skupina; nepovinné, povolené hodnoty I, II, III",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.adr.packagingType",
              defaultMessage:
                "ADR - typ obalu; povolené hodnoty BBG, BS, CT, CYL, DR, CI, BX, BG, IBC",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.adr.environmentalHazard",
              defaultMessage:
                "ADR - nebezpečné pro životní prostředí; příznak; nepovinná hodnota",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.adr.quantity",
              defaultMessage:
                "ADR - množství ADR látky; desetinné číslo větší než 0",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.adr.quantityType",
              defaultMessage:
                "ADR - typ množství; povolené hodnoty jsou 1 (omezené množství dle 3.4. LQ) nebo 2 (podlimitní množství dle 1.1.3.6.) nebo 3 (plná - nadlimitní ADR) nebo 4 (vyňaté množství dle 3.5. EQ) nebo 5 (Prázdné obaly)",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.adr.handlingUnitsQuantity",
              defaultMessage:
                "ADR - počet manipulačních jednotek; přirozené číslo",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "consignment.import.dataFormat.adr.grossWeight",
              defaultMessage: "ADR - celková váha; desetinné číslo větší než 0",
            })}
          </li>
        </ol>
      </Col>
    </Row>
  );
};

export default ConsignmentImportInstructions;
